/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Input,
  Button,
  Form,
  message,
  Spin,
  Upload,
  Modal,
} from "antd";
import { useDispatch } from "react-redux";
import {
  capitalize,
  capitalise,
  getUserAndPremiseId,
  capitaliseWithHyphen,
  showErrorMessage,
} from "../../../utils";
import { shallowEqual, useSelector } from "react-redux";

import moment from "moment";
import { getPremiseId, getToken } from "../../../utils/worker";
import { getStaffOnboardClear } from "../../../actionsMethods/onboardingMethods";
import API from "../../../api";
import urls from "../../../api/urls";

import Smcs_Loader from "../../../assests/images/loader-new.gif";
import StaffForm from "./StaffForm";
import { RBAC_TEST_EDIT_EMAIL } from "../../../services/staffOnboarding/rbacApi";
import {
  createRbacUser,
  fetchRbacLocationByHubCpId,
  fetchRbacUserByEmail,
  sendRbacEmailVerificationCode,
  updateRbacUser,
  verifyRbacEmailVerificationCode,
  verifyRbacMobileNumberKey,
} from "../../../services/staffOnboarding/rbacUsersService";
import {
  mapRbacUserToStaffForm,
  mapStaffFormToRbacCreatePayload,
  mapStaffFormToRbacUpdatePayload,
} from "../../../services/staffOnboarding/rbacUserPayload";

const {
  GET_BANK_DETAILS_BY_IFSC,
  SEND_SMS_PHONE,
  VERIFY_PHONE_OTP,
  GET_STAFF_ROLES,
} = urls;

export const CreateStaff = ({ handleSubmit = () => {}, updateStaff }) => {
  const dispatch = useDispatch();

  const getFormData = useSelector(
    (state) => state?.onboardingReducer?.getStaffOnboardReducer,
    shallowEqual
  );

  const [form] = Form.useForm();
  const [modalForm] = Form.useForm();
  const [emailModalForm] = Form.useForm();
  const premiseId = getPremiseId();
  const getUserInfo = getUserAndPremiseId();
  const userId = getUserInfo?.userId;
  const token = getToken();

  const [visible, setVisible] = useState(false);
  const [emailModalVisible, setEmailModalVisible] = useState(false);

  const [roleOptions, setRoleOptions] = useState();
  const [showVerifyEmail, setShowVerifyEmail] = useState(false);
  const [emailOtpVerified, setEmailOtpVerified] = useState(false);
  const [driverSelected, setdriverSelected] = useState(false);
  const [showVerify, setShowVerify] = useState();
  const [showBank, setshowBank] = useState();
  const [phnOtpVerified, setPhnOtpVerified] = useState(false);
  const [selectedId, setselectedId] = useState();
  const [loading, setloading] = useState(false);
  const [roleSelected, setRoleSelected] = useState();
  const [bankDetails, setBankDetails] = useState();
  const [fileList, setfileList] = useState([]);
  const [editFile, setEditFile] = useState(null);
  const [staffEditData, setStaffEditData] = useState(null);
  const [rbacEditUser, setRbacEditUser] = useState(null);
  const [originalEditContact, setOriginalEditContact] = useState("");
  const [originalEditEmail, setOriginalEditEmail] = useState("");
  const { result: reduxFormResult } = getFormData;
  const isEditMode = Boolean(updateStaff);
  const formResult = isEditMode ? staffEditData : staffEditData || reduxFormResult;
  const editFormPopulatedKeyRef = useRef(null);

  const [idTypes, setIdTypes] = useState([
    {
      label: "Aadhar card",
      value: "aadhar",
    },
    {
      label: "Voter Id",
      value: "VOTER",
    },
    {
      label: "PAN Card",
      value: "pan",
    },
    {
      label: "Driving Licence",
      value: "DL",
    },
  ]);
  const dlClass = [
    {
      label: "MC 50CC",
      value: "MC 50CC",
    },
    {
      label: "MCWOG/FVG",
      value: "MCWOG/FVG",
    },
    {
      label: "MC EX50CC",
      value: "MC EX50CC",
    },
    {
      label: "MGV",
      value: "MGV",
    },
    {
      label: "HMV",
      value: "HMV",
    },
    {
      label: "HGMV",
      value: "HGMV",
    },
    {
      label: "HPMV",
      value: "HPMV",
    },
    {
      label: "LMV",
      value: "LMV",
    },
    {
      label: "LMV-NT",
      value: "LMV-NT",
    },
    {
      label: "HTV",
      value: "HTV",
    },
    {
      label: "Trailer",
      value: "Trailer",
    },
  ];
  const idTypesMain = [
    {
      label: "Aadhar card",
      value: "aadhar",
    },
    {
      label: "Voter Id",
      value: "VOTER",
    },
    {
      label: "PAN Card",
      value: "pan",
    },
    {
      label: "Driving License",
      value: "DL",
    },
  ];

  const populateStaffFormFromRbac = useCallback(
    (mappedData) => {
      if (!mappedData) {
        return;
      }

      form.setFieldsValue({
        employeeId: mappedData.employeeId,
        firstName: mappedData.firstName,
        lastName: mappedData.lastName,
        emailId: mappedData.emailId,
        contactNumber: mappedData.contactNumber,
        role: mappedData.role,
        idType: mappedData.idType,
        idNumber: mappedData.idNumber,
        bankDetail: false,
      });

      setEditFile(mappedData?.idUrl);
      setRoleSelected(mappedData?.role);
      setselectedId(mappedData?.idType);
      setshowBank(false);

      const roleLabel = String(mappedData?.label || "").toUpperCase();
      if (
        roleLabel.includes("DRIVER") ||
        roleLabel.includes("DELIVERYBOY") ||
        roleLabel.includes("FIELD EXECUTIVE") ||
        roleLabel.includes("CPFIELDEXECUTIVE")
      ) {
        setdriverSelected(true);
      } else {
        setdriverSelected(false);
        setIdTypes([...idTypesMain]);
      }
    },
    [form]
  );

  useEffect(() => {
    const loadStaffForEdit = async () => {
      if (!updateStaff) {
        setStaffEditData(null);
        setRbacEditUser(null);
        setOriginalEditContact("");
        setOriginalEditEmail("");
        dispatch(getStaffOnboardClear());
        return;
      }

      dispatch(getStaffOnboardClear());
      setStaffEditData(null);
      setRbacEditUser(null);
      setOriginalEditContact("");
      setOriginalEditEmail("");
      editFormPopulatedKeyRef.current = null;
      setloading(true);
      const editEmail = updateStaff || RBAC_TEST_EDIT_EMAIL;
      const { user, error } = await fetchRbacUserByEmail(editEmail);
      setloading(false);

      if (error) {
        showErrorMessage(error);
        setStaffEditData(null);
        setRbacEditUser(null);
        return;
      }

      const mappedData = mapRbacUserToStaffForm(user);
      setRbacEditUser(user);
      setStaffEditData(mappedData);
      setOriginalEditContact(mappedData.contactNumber || "");
      setOriginalEditEmail(String(mappedData.emailId || "").trim().toLowerCase());
      populateStaffFormFromRbac(mappedData);
      setPhnOtpVerified(true);
      setEmailOtpVerified(true);
      setShowVerify(false);
      setShowVerifyEmail(false);
    };

    loadStaffForEdit();
  }, [updateStaff, dispatch, populateStaffFormFromRbac]);

  useEffect(() => {
    getALLRoles();
  }, []);

  useEffect(() => {
    modalForm.resetFields();
    if (visible === true) {
      setPhnOtpVerified(false);
    }
  }, [visible]);

  useEffect(() => {
    emailModalForm.resetFields();
  }, [emailModalVisible]);

  useEffect(() => {
    if (!staffEditData?.role) {
      return;
    }

    setRoleOptions((prev = []) => {
      const exists = prev.some((option) => option.value === staffEditData.role);
      if (exists) {
        return prev;
      }

      return [
        ...prev,
        {
          label: staffEditData.label || staffEditData.role,
          value: staffEditData.role,
        },
      ];
    });
  }, [staffEditData]);

  useEffect(() => {
    if (!formResult) {
      editFormPopulatedKeyRef.current = null;
      form.resetFields();
      setEmailOtpVerified(false);
      setShowVerifyEmail(false);
      return;
    }

    const populateKey =
      formResult?.userId || formResult?.staffId || updateStaff || "edit";
    if (editFormPopulatedKeyRef.current === populateKey) {
      return;
    }

    editFormPopulatedKeyRef.current = populateKey;
    form.setFieldsValue({
      employeeId: formResult.employeeId,
      firstName: formResult.firstName,
      lastName: formResult.lastName,
      emailId: formResult.emailId,
      contactNumber: formResult.contactNumber,
      role: formResult.role,
      idType: formResult.idType,
      idNumber: formResult.idNumber,
      idUrl: formResult.idUrl,
      bankDetail: false,
    });
    setEditFile(formResult?.idUrl);
    setRoleSelected(formResult?.role);

    const roleLabel = String(formResult?.label || "").toUpperCase();
    if (
      roleLabel.includes("DRIVER") ||
      roleLabel.includes("DELIVERYBOY") ||
      roleLabel.includes("FIELD EXECUTIVE") ||
      roleLabel.includes("CPFIELDEXECUTIVE")
    ) {
      setdriverSelected(true);
    } else {
      setdriverSelected(false);
      setIdTypes([...idTypesMain]);
    }
    setselectedId(formResult?.idType);
    setshowBank(formResult?.bankDetail || false);
  }, [formResult, form, updateStaff]);

  const isDriverRoleOption = (roleItem = {}) => {
    const label = String(roleItem?.label || "").toUpperCase();
    const role = String(roleItem?.role || "").toUpperCase();
    return label.includes("DRIVER") || role.includes("DRIVER");
  };

  const getALLRoles = async () => {
    setloading(true);
    let response = await API.Api(GET_STAFF_ROLES).getWithUserNPremiseHeader();
    if (response?.status) {
      setloading(false);
      let temp = response?.response?.data
        ?.filter((val) => !isDriverRoleOption(val))
        ?.map((val) => {
          return { label: capitalize(val?.label), value: val?.role };
        });
      setRoleOptions(temp);
    } else {
      setloading(false);
      message.error(response?.response?.data?.message || "Network Error");
    }
  };

  const checkStaffEmailAvailable = async (emailId) => {
    const raw =
      emailId !== undefined && emailId !== null
        ? emailId
        : form.getFieldValue("emailId");
    const trimmed = typeof raw === "string" ? raw.trim().toLowerCase() : raw;
    if (!trimmed) {
      setShowVerifyEmail(false);
      return;
    }

    if (originalEditEmail && trimmed === originalEditEmail) {
      setEmailOtpVerified(true);
      setShowVerifyEmail(false);
      return;
    }

    setShowVerifyEmail(true);
  };

  const resolveStaffEditUserId = () =>
    rbacEditUser?.userId ||
    rbacEditUser?.id ||
    formResult?.userId ||
    formResult?.staffId;

  const sendStaffEmailMail = async (emailId) => {
    const raw =
      emailId !== undefined && emailId !== null
        ? emailId
        : form.getFieldValue("emailId");
    const trimmed = typeof raw === "string" ? raw.trim() : raw;
    if (!trimmed) {
      setShowVerifyEmail(false);
      return false;
    }

    const editUserId = isEditMode ? resolveStaffEditUserId() : undefined;

    if (isEditMode && !editUserId) {
      showErrorMessage("User id is missing. Unable to send verification code.");
      setShowVerifyEmail(false);
      return false;
    }

    setloading(true);
    const { message: successMessage, error } = await sendRbacEmailVerificationCode(
      trimmed,
      editUserId
    );
    setloading(false);

    if (error) {
      setShowVerifyEmail(false);
      setEmailModalVisible(false);
      showErrorMessage(error);
      return false;
    }

    message.success({
      content: successMessage || "Verification email sent successfully",
      duration: 2,
    });
    return true;
  };

  const verifyEmailExists = (emailId) => checkStaffEmailAvailable(emailId);

  const openEmailVerifyModal = async () => {
    const sent = await sendStaffEmailMail();
    if (sent) {
      setEmailModalVisible(true);
    }
  };

  const handleCloseEmailModal = () => {
    setEmailModalVisible(false);
  };

  const verifyStaffEmailOtp = async (values) => {
    const emailId = form.getFieldValue("emailId")?.trim();

    if (!emailId) {
      showErrorMessage("Email is required.");
      return;
    }

    const editUserId = isEditMode ? resolveStaffEditUserId() : undefined;

    if (isEditMode && !editUserId) {
      showErrorMessage("User id is missing. Unable to verify code.");
      return;
    }

    setloading(true);
    const { verified, message: successMessage, error } =
      await verifyRbacEmailVerificationCode(emailId, values.otp, editUserId);
    setloading(false);

    if (verified) {
      message.success(successMessage || "Email verified successfully");
      setEmailOtpVerified(true);
      setEmailModalVisible(false);
      setShowVerifyEmail(false);
      emailModalForm.resetFields();
      return;
    }

    showErrorMessage(error || "Wrong OTP");
  };

  const checkPhnNumExists = async (values) => {
    if (originalEditContact && values === originalEditContact) {
      setPhnOtpVerified(true);
      setShowVerify(false);
      return;
    }

    setloading(true);
    const { exists, error } = await verifyRbacMobileNumberKey(values);
    setloading(false);

    if (error) {
      showErrorMessage(error);
      return;
    }

    if (exists) {
      showErrorMessage("Phone number already exists");
      return;
    }

    setShowVerify(true);
  };
  const sentPhoneOtp = async () => {
    setloading(true);

    let phoneNum = form.getFieldValue("contactNumber");

    let response = await API.Api(SEND_SMS_PHONE).post({
      mobileNo: phoneNum,
    });

    if (response?.response?.data === true) {
      setloading(false);
      message.info("OTP has sent the given number");
    } else {
      setloading(false);
      showErrorMessage("Failed to send the OTP");
    }
  };

  const createPersonalDetails = async (values) => {
    // dateOfBirth and alternativeNumber are UI-only and are not sent to RBAC
    const {
      dateOfBirth: _dateOfBirth,
      alternativeNumber: _alternativeNumber,
      ...rbacFormValues
    } = values || {};
    const isNewStaff = !formResult;
    const contactChanged =
      !isNewStaff && rbacFormValues?.contactNumber !== originalEditContact;
    const emailChanged =
      !isNewStaff &&
      String(rbacFormValues?.emailId || "")
        .trim()
        .toLowerCase() !== originalEditEmail;

    if ((isNewStaff || emailChanged) && !emailOtpVerified) {
      message.warning("Please verify your email before submitting.");
      return;
    }
    if ((isNewStaff || contactChanged) && !phnOtpVerified) {
      message.warning("Please verify your contact number before submitting.");
      return;
    }
    setloading(true);

    const { locationId, error: locationError } = await fetchRbacLocationByHubCpId();

    if (locationError || !locationId) {
      setloading(false);
      showErrorMessage(locationError || "Failed to resolve RBAC location.");
      return;
    }

    if (formResult === null) {
      const { formData, error } = mapStaffFormToRbacCreatePayload(
        rbacFormValues,
        fileList,
        locationId
      );

      if (error || !formData) {
        setloading(false);
        showErrorMessage(error || "Failed to prepare staff payload.");
        return;
      }

      const { data, error: createError } = await createRbacUser(formData);
      setloading(false);

      if (createError) {
        showErrorMessage(createError);
        return;
      }

      if (data?.userId) {
        localStorage.setItem("staff", data.userId);
      }

      message.success("Staff onboarded successfully");
      handleSubmit();
      return;
    }

    const userId =
      rbacEditUser?.userId ||
      rbacEditUser?.id ||
      formResult?.userId ||
      formResult?.staffId;

    if (!userId) {
      setloading(false);
      showErrorMessage("RBAC user id is missing. Unable to update staff.");
      return;
    }

    const { formData, error } = mapStaffFormToRbacUpdatePayload(
      rbacFormValues,
      rbacEditUser || formResult?._rbacUser || {},
      fileList,
      locationId
    );

    if (error || !formData) {
      setloading(false);
      showErrorMessage(error || "Failed to prepare staff update payload.");
      return;
    }

    updateStaffOnboard(userId, formData);
  };

  const updateStaffOnboard = async (userId, formData) => {
    setloading(true);

    const { data, error, message: apiMessage, success } = await updateRbacUser(
      userId,
      formData
    );
    setloading(false);

    if (error) {
      showErrorMessage(error);
      return;
    }

    if (success === false) {
      showErrorMessage(apiMessage || "Failed to update staff");
      return;
    }

    if (data && (data?.userId || data?.id)) {
      setRbacEditUser(data);
      setStaffEditData(mapRbacUserToStaffForm(data));
    }

    message.success(apiMessage || "User updated successfully");
    handleSubmit();
  };

  const handleCloseModal = () => {
    setVisible(false);
  };

  const verifyPhoneOtp = async (values) => {
    setloading(true);

    let phoneNum = form.getFieldValue("contactNumber");
    let response = await API.Api(VERIFY_PHONE_OTP).post({
      mobileNo: phoneNum,
      otp: values.otp,
    });

    if (response?.response?.data === true) {
      setloading(false);

      message.success("Phone number verified successfully");
      setPhnOtpVerified(true);
      setVisible(false);
      setShowVerify(false);
    } else {
      setloading(false);
      showErrorMessage("Wrong OTP");
    }
  };

  function handleSelectedId(params) {
    setselectedId(params);
    form.setFieldValue("idNumber", null);
  }

  const fileProps = {
    name: "files",
    multiple: true,
    listType: "picture",
    showUploadList: true,
    customRequest: ({ onSuccess, file }) => {
      onSuccess(file);
    },
    className: "upload-list-inline staff-onboard-upload",

    fileList:
      editFile !== null
        ? [
            {
              name: "",
              url: editFile,
            },
          ]
        : fileList,
  };

  const handleChange = (info) => {
    if (info?.file?.status === "done") {
      setEditFile(null);
      form.setFieldValue("idUrl", info?.file?.name || "uploaded");
      message.success("Document added successfully");
    }
    if (info?.file?.status === "error") {
      showErrorMessage("File not Supported");
    }
    setfileList(
      (info?.fileList || []).map((file) => ({
        ...file,
        name: "",
      }))
    );
  };

  function handleRemoveFile() {
    message.success("File removed successfully");
    setfileList([]);
    setEditFile(null);
  }

  const headers = {
    Authorization: token,
    "SMCS-PREMISE-ID": premiseId?.split("Bearer")[1],
    "USER-ID": userId,
  };

  function handleRadioChange(e) {
    setshowBank(true);
    if (e.target.value === false) {
      setshowBank(false);
      form.setFieldValue("bankDetail", false);
      form.setFieldsValue({
        accountHolderName: "",
        accountNumber: "",
        ifscCode: "",
        bankName: "",
        branchName: "",
      });
    } else {
      form.setFieldValue("bankDetail", true);
    }
  }

  const checkIFSC = async (values) => {
    let response = await API.Api(
      GET_BANK_DETAILS_BY_IFSC + `?ifscCode=${values}`
    ).get();
    if (response?.status) {
      setBankDetails(response?.response?.data);
    } else {
      form.setFieldsValue({
        bankName: "",
        branchName: "",
      });
    }
  };

  useEffect(() => {
    if (bankDetails?.IFSC) {
      form.setFieldsValue({
        bankName: bankDetails?.BANK,
        branchName: capitaliseWithHyphen(bankDetails?.BRANCH),
      });
    }
  }, [bankDetails]);

  function handleRoleChange(e) {
    setRoleSelected(e);
    form.setFieldsValue({
      idType: null,
      idNumber: null,
    });

    if (e.includes("DRIVER") || e.includes("CPFIELDEXECUTIVE")) {
      setdriverSelected(true);
      let filterId = idTypes?.filter((val) => val.value === "DL");
      setIdTypes([...filterId]);
    } else {
      setdriverSelected(false);
      setIdTypes([...idTypesMain]);
    }
  }

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const getPreviewImageSrc = (file) => {
    if (file?.url) {
      return file.url;
    }

    if (file?.preview) {
      return file.preview;
    }

    if (file?.originFileObj) {
      return URL.createObjectURL(file.originFileObj);
    }

    return file?.thumbUrl || "";
  };

  const handlePreview = async (file) => {
    const fileLabel =
      file?.name || file?.url?.substring(file?.url?.lastIndexOf("/") + 1);
    const isPdf =
      file?.type === "application/pdf" ||
      String(fileLabel || "")
        .toLowerCase()
        .includes(".pdf");

    if (isPdf) {
      window.open(file?.url || file?.response);
      return;
    }

    let imageSrc = getPreviewImageSrc(file);

    if (!imageSrc && file?.originFileObj) {
      imageSrc = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file.originFileObj);
      });
    }

    setPreviewImage(imageSrc || file?.thumbUrl);
    setPreviewOpen(true);
  };
  const handleCancel = () => setPreviewOpen(false);

  const beforeUpload = (file, onSuccess) => {
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "application/pdf";
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (file) {
      let checkSameFile = fileList
        ?.map((val) => val?.name)
        .some((val) => val === file?.name);

      if (file?.name?.includes("jfif")) {
        showErrorMessage("File not supported");
        return Upload.LIST_IGNORE;
      }
      if (checkSameFile) {
        showErrorMessage("Same file cannot be uploaded again");
        return Upload.LIST_IGNORE;
      }
      if (!isLt2M) {
        showErrorMessage("File size should be less than 10MB");
        return Upload.LIST_IGNORE;
      }
      if (!isJpgOrPng) {
        showErrorMessage("File not supported");
        return Upload.LIST_IGNORE;
      }
      return true;
    } else {
      if (onSuccess) {
        message.success("File uploaded");
      }
      onSuccess("ok");
      return true;
    }
  };

  const minDate = moment().subtract(18, "years");
  const disableDaysBeforeToday = useCallback(
    (d) => {
      if (d == null) {
        return null;
      }
      return minDate != null && d.isAfter(minDate) && !d.isSame(minDate, "day");
    },
    [minDate]
  );

  return (
    <Spin
      spinning={loading}
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <div className="master-main-container">
        <Modal
          open={previewOpen}
          title={null}
          footer={null}
          onCancel={handleCancel}
        >
          <img
            alt="Document preview"
            style={{
              width: "100%",
              maxHeight: "70vh",
              objectFit: "contain",
            }}
            src={previewImage}
          />
        </Modal>
        <Modal
          title={null}
          open={visible}
          maskClosable={false}
          onCancel={handleCloseModal}
          width={380}
          loading={false}
          className="staff-onboard-modal staff-onboard-modal--otp"
          footer={null}
          destroyOnClose
        >
          <Form
            form={modalForm}
            onFinish={verifyPhoneOtp}
            layout="vertical"
            className="staff-onboard-modal__otp-form global-form"
          >
            <Form.Item
              name="otp"
              label="OTP"
              rules={[
                {
                  message: "OTP is required",
                  required: true,
                },
              ]}
            >
              <Input placeholder="Enter OTP" maxLength={6} />
            </Form.Item>
            <div className="staff-onboard-modal__otp-actions">
              <Button htmlType="submit" className="save-btn">
                SUBMIT
              </Button>
            </div>
          </Form>
        </Modal>

        <Modal
          title={null}
          open={emailModalVisible}
          maskClosable={false}
          onCancel={handleCloseEmailModal}
          width={380}
          loading={false}
          className="staff-onboard-modal staff-onboard-modal--otp"
          footer={null}
          destroyOnClose
        >
          <Form
            form={emailModalForm}
            onFinish={verifyStaffEmailOtp}
            layout="vertical"
            className="staff-onboard-modal__otp-form global-form"
          >
            <Form.Item
              name="otp"
              label="OTP"
              rules={[
                {
                  message: "OTP is required",
                  required: true,
                },
              ]}
            >
              <Input placeholder="Enter OTP" maxLength={6} />
            </Form.Item>
            <div className="staff-onboard-modal__otp-actions">
              <Button htmlType="submit" className="save-btn">
                SUBMIT
              </Button>
            </div>
          </Form>
        </Modal>

        <StaffForm
          form={form}
          createPersonalDetails={createPersonalDetails}
          disableDaysBeforeToday={disableDaysBeforeToday}
          minDate={minDate}
          phnOtpVerified={phnOtpVerified}
          emailOtpVerified={emailOtpVerified}
          setEmailOtpVerified={setEmailOtpVerified}
          formResult={formResult}
          checkPhnNumExists={checkPhnNumExists}
          setPhnOtpVerified={setPhnOtpVerified}
          setShowVerify={setShowVerify}
          setVisible={setVisible}
          sentPhoneOtp={sentPhoneOtp}
          showVerify={showVerify}
          showVerifyEmail={showVerifyEmail}
          setShowVerifyEmail={setShowVerifyEmail}
          verifyEmailExists={verifyEmailExists}
          openEmailVerifyModal={openEmailVerifyModal}
          handleRoleChange={handleRoleChange}
          roleOptions={roleOptions}
          idTypes={idTypes}
          handleSelectedId={handleSelectedId}
          roleSelected={roleSelected}
          driverSelected={driverSelected}
          dlClass={dlClass}
          fileProps={fileProps}
          handleChange={handleChange}
          handleRemoveFile={handleRemoveFile}
          handlePreview={handlePreview}
          beforeUpload={beforeUpload}
          headers={headers}
          handleRadioChange={handleRadioChange}
          showBank={showBank}
          capitalise={capitalise}
          checkIFSC={checkIFSC}
          selectedId={selectedId}
          originalEditContact={originalEditContact}
          originalEditEmail={originalEditEmail}
        />
      </div>
    </Spin>
  );
};

export default CreateStaff;
